import React from 'react';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';

import ShowcaseCard from '../../components/ShowcaseCard';

export default function Featured({data}) {
    const navigate = useNavigate();

    return (
        <>
            <h2 className='title'>Featured Projects</h2>
            {data.map((event) => (
                <ShowcaseCard key={event.id ?? event.name} data={event} />
            ))}
            <div className='flex justify-content-center lg:justify-content-end'>
                <Button
                    label="View All Projects"
                    icon="pi pi-bars"
                    rounded
                    onClick={() => navigate('/projects/')}
                    size='small'
                />
            </div>
        </>
    );
}
